import React from "react";
import { Divider, Grid } from "@material-ui/core";
import { RaceEntryOverview } from "../../../../model/RaceEntryOverview";
import EntryStatItem from "./EntryStatItem";

type Props = {
    raceId: string;
    race: RaceEntryOverview;
};

const EntryOverviewItems = (props: Props) => {

    const render = () => {
        const { raceId, race } = props;

        return (<>
            <Grid container spacing={2}>
                <Grid item xs={5}>
                    Maximalt antal deltagare:
                </Grid>
                <Grid item xs={7}>
                    <b>{race.maxParticipants}</b>
                </Grid>

                <Grid item xs={5}>
                    Antal anmälda deltagare:
                </Grid>
                <Grid item xs={7}>
                    <b>{race.numEntered}</b>
                </Grid>
                <Grid item xs={5}>
                    Antal reserverade platser:
                </Grid>
                <Grid item xs={7}>
                    <b>{race.numReserved}</b>
                </Grid>
                <Grid item xs={5}>
                    Antal otilldelade företagsplatser:
                </Grid>
                <Grid item xs={7}>
                    <b>{race.numCompanyReserved}</b>
                </Grid>
                <Grid item xs={5}>
                    Platser kvar:
                </Grid>
                <Grid item xs={7}>
                    <b>{race.numRemaining}</b>
                </Grid>

                <Grid item xs={12}><Divider /></Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={2} style={{ fontWeight: "bold" }}>
                    Startled
                </Grid>
                <Grid item xs={2} style={{ fontWeight: "bold" }}>
                    Max platser
                </Grid>
                <Grid item xs={2} style={{ fontWeight: "bold" }}>
                    Säljbara platser
                </Grid>
                <Grid item xs={2} style={{ fontWeight: "bold" }}>
                    Antal deltagare
                </Grid>
                <Grid item xs={1} style={{ fontWeight: "bold" }}>
                    Antal pågående köp
                </Grid>
                <Grid item xs={1} style={{ fontWeight: "bold" }}>
                    Otilldelade företagsplatser
                </Grid>
                <Grid item xs={1} style={{ fontWeight: "bold" }}>
                    Lediga platser
                </Grid>
                <Grid item xs={1} style={{ fontWeight: "bold" }}>
                    Publikt lediga platser
                </Grid>

                {race.startGroups && race.startGroups.map((group, idx) => {
                    return <EntryStatItem key={idx} raceId={raceId} group={group} />;
                })}
            </Grid>
        </>);
    };

    return render();
};

export default EntryOverviewItems;
